import dayjs from 'dayjs';
import { IBasket } from 'models/basket.model';
import { BasketOrder } from 'models/basket-order.model';
import { ITransporterMember } from 'models/transporter-member.model';
import { Transporter } from 'models/transporter.model';
import { User } from './user.model';
import { PaymentPeriodEnum } from './enums/payment-period.enum';
import { LIST_PAYMENT_METHOD, PaymentMethod } from './payment-method.model';
import { PaymentMethodEnum } from './enums/payment-method.enum';

export interface ICustomer {
  id?: number;
  userTypology?: PaymentMethodEnum;
  paymentPeriod?: PaymentPeriodEnum;
  marginRate?: number;
  sepaAlias?: string | null;
  accountingCode?: string;
  acceptedCGV?: boolean;
  transporterAlias?: string;
  paymentDelay?: number;
  creationDate: string;
  commentTransporter?: string;
  basket?: IBasket;
  currentBasketOrder?: IBasket;
  transporterMember?: ITransporterMember;
  transporter?: Transporter;
  user: User;
}

export class Customer {
  public user!: User;
  public id!: number;
  public userTypology: PaymentMethod;
  public paymentPeriod?: PaymentPeriodEnum;
  public marginRate?: number;
  public sepaAlias?: string | null;
  public accountingCode?: string;
  public acceptedCGV: boolean = false;
  public transporterAlias?: string;
  public paymentDelay?: number;
  public creationDate: dayjs.Dayjs;
  public commentTransporter?: string;
  public basket?: IBasket;
  public currentBasketOrder?: BasketOrder;
  public transporterMember?: ITransporterMember;
  public transporter?: Transporter;

  constructor(data: Partial<ICustomer> = {}) {
    Object.assign(this, data);
    this.userTypology = data.userTypology ? LIST_PAYMENT_METHOD[data.userTypology] : LIST_PAYMENT_METHOD[PaymentMethodEnum.CB];
    this.creationDate = data.creationDate ? dayjs(data.creationDate) : dayjs(Date.now());
    this.user = new User(data.user);
    this.transporter = new Transporter(data.transporter);
    this.currentBasketOrder = new BasketOrder(data.currentBasketOrder || {});
  }

  public serialize(): Partial<ICustomer> {
    return {
      id: this.id,
      user: this.user?.serialize(),
      userTypology: this.userTypology?.code,
      paymentPeriod: this.paymentPeriod,
      marginRate: this.marginRate,
      sepaAlias: this.sepaAlias,
      accountingCode: this.accountingCode,
      acceptedCGV: this.acceptedCGV,
      transporterAlias: this.transporterAlias,
      paymentDelay: this.paymentDelay,
      creationDate: dayjs(this.creationDate).isValid() ? dayjs(this.creationDate).toJSON() : undefined,
      commentTransporter: this.commentTransporter,
      basket: this.basket,
      transporterMember: this.transporterMember,
      transporter: { id: this.transporter?.id },
      currentBasketOrder: this.currentBasketOrder?.id ? { id: this.currentBasketOrder?.id } : undefined,
    };
  }
}
